module.exports = __webpack_public_path__ + "img/RefreshTab2.d61289f2.svg";